import { BindingCreator } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { invoiceSharedComponentsTranslationKeys } from '../../../translations';

import { InvoiceCreateFormCompanyNameFormBeanPart } from './InvoiceCreateFormCompanyName.types';

const COMPANY_NAME_FIELD_NAME = 'companyName';
const COMPANY_NAME_MAX_LENGTH = 255;

export type InvoiceCreateFormCompanyNameFieldFormBeanPart = {
   [COMPANY_NAME_FIELD_NAME]: string;
};

type InvoiceCreateFormCompanyNameTextInputProps = {
   readonly register: BindingCreator<InvoiceCreateFormCompanyNameFormBeanPart, typeof COMPANY_NAME_FIELD_NAME>;
};

export const InvoiceCreateFormCompanyNameTextInput = (
   props: InvoiceCreateFormCompanyNameTextInputProps
): JSX.Element => {
   return (
      <TextInput
         controller={props.register(COMPANY_NAME_FIELD_NAME, {
            required: true,
            maxLength: COMPANY_NAME_MAX_LENGTH,
         })}
         testId={COMPANY_NAME_FIELD_NAME}
         label={invoiceSharedComponentsTranslationKeys.companyName}
      />
   );
};
